<script lang="ts">
    import {onMount} from "svelte";

    export let label;
    export let type = 'text';
    export let value;
    export let className = null;
    export let isDisabled = false;
    export let alert: boolean = false;
    export let alertMessage: string = 'Error';
    let fill = false;
    let focus = false;

    onMount(() => {
        setStatus();
    });

    export function setStatus() {
        if (value !== '' && value !== undefined) {
            fill = true;
            focus = true;
        } else {
            fill = false;
            focus = false;
        }
    }
</script>
<div class="naui-field {className}" class:active={fill}>
    <div class="naui-field-back" class:fill={fill}>
        <label class:focus={focus}>{label}</label>
        {#if type === 'email'}
            <input class="naui-input w-100"
                   readonly={isDisabled}
                   type="email"
                   bind:value={value}
                   on:input
                   on:change
                   on:focus={()=> fill=true}
                   on:focusin={()=>focus=false}
            />
        {:else if type === 'password'}
            <input
                    class="naui-input w-100"
                    readonly={isDisabled}
                    type="password"
                    bind:value={value}
                    on:input
                    on:change
                    on:focus={()=> fill=true}
                    on:focusin={()=>focus=false}
            />
        {:else if type === 'number'}
            <input class:alert={alert && !isDisabled}
                   class="naui-input w-100"
                   readonly={isDisabled}
                   type="number"
                   step="0.1"
                   bind:value={value}
                   on:input
                   on:change
                   on:focus={()=>fill=true}
                   on:focusin={()=>focus=false}
            />
        {:else}
            <input
                    class="naui-input w-100"
                    readonly={isDisabled}
                    type="text"
                    bind:value={value}
                    on:input
                    on:change
                    on:keyup
                    on:focus={()=> fill=true}
                    on:focusin={()=>focus=false}
            />
        {/if}
        {#if alert && !isDisabled}
            {#if alertMessage}
                <small class="alert-message">
                    {alertMessage}
                </small>
            {/if}
        {/if}
    </div>
</div>

<style>
    .alert-message {
        color: red;
        font-weight: bold;
    }
</style>